import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';

const SEND_BILL = gql`
  mutation SendBillByEmail($sendBillEmailInput: SendBillEmailInput!) {
    sendBillByEmail(sendBillEmailInput: $sendBillEmailInput) {
      error {
        reason
      }
    }
  }
`;

export const useSendBill = billId => {
  const [sendBill] = useMutation(SEND_BILL);

  return {
    sendBill: details => {
      const { emailTo, emailFrom, emailCc, subject, message } = details || {};

      return sendBill({
        variables: {
          sendBillEmailInput: {
            notificationEmailInput: {
              emailTo,
              replyTo: emailFrom,
              ccTo: emailCc,
              subject,
              textBody: message
            },
            billId
          }
        },
        refetchQueries: ['getBillDetails', 'getBillingTransactionSummary'],
        awaitRefetchQueries: true
      });
    }
  };
};

export default useSendBill;
